import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function PauseIcon({ fill = '#051336', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      aria-hidden={ariaHidden}
    >
      <path
        d="M2.91797 11.375V2.625C2.91797 2.04167 3.20964 1.75 3.79297 1.75H4.95964C5.54297 1.75 5.83464 2.04167 5.83464 2.625V11.375C5.83464 11.9583 5.54297 12.25 4.95964 12.25H3.79297C3.20964 12.25 2.91797 11.9583 2.91797 11.375ZM9.04297 12.25H10.2096C10.793 12.25 11.0846 11.9583 11.0846 11.375V2.625C11.0846 2.04167 10.793 1.75 10.2096 1.75H9.04297C8.45964 1.75 8.16797 2.04167 8.16797 2.625V11.375C8.16797 11.9583 8.45964 12.25 9.04297 12.25Z"
        fill={fill}
      />
    </svg>
  );
}

export default PauseIcon;
